export enum GamePlayState {
  BEFORE_START = 'before-start',
  ACTIVE = 'active',
  EXPIRED = 'expired',
}